import React, { ReactNode, useEffect } from "react";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import "components/builderShell/builderToolbarMenuView.scss";
import { useWebsiteBuilderToolbarContext } from "../../websiteBuilderToolbarContext";
import { TWebsiteBuilderDraggableNode, TWebsiteBuilderDraggableNodeDropItemType } from "../../../../nodes/websiteBuilderNode";
import { useAppDispatch } from "hooks/redux";
import { websiteBuilderSelectNode } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";

interface IDraggableNodeProps {
  item: TWebsiteBuilderDraggableNode;
  children: ReactNode;
}

interface IDraggableNodeDragState {
  isDragging: boolean;
}

export function DraggableNode(props: IDraggableNodeProps) {
  const { item, children } = props;

  const dispatch = useAppDispatch();

  const { handleSetToolbarMenuType } = useWebsiteBuilderToolbarContext();

  const [dragState, drag, dragPreview] = useDrag<TWebsiteBuilderDraggableNode, unknown, IDraggableNodeDragState>(() => {
    const type: TWebsiteBuilderDraggableNodeDropItemType = `website-builder-${item.type}`;
    
    return {
      item,
      type,
      collect: (monitor): IDraggableNodeDragState => {
        return {
          isDragging: !!monitor.isDragging(),
        };
      },
    };
  }, [item]);

  useEffect(() => {
    dragPreview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  useEffect(() => {
    if (dragState.isDragging) {
      dispatch(websiteBuilderSelectNode({ selectedNode: null }));
      handleSetToolbarMenuType("none");
    }
  }, [dragState.isDragging, handleSetToolbarMenuType]);

  return (
    <div
      ref={drag}
      className="builder-toolbar-palette-item"
    >
      {children}
    </div>
  );
}
